import React, { Component } from 'react';
import {Link} from 'react-router-dom'

class TabProject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [
                {
                    id: 1,
                    classnames: 'project-item plywood mdf',
                    srcimg: 'assets/img/project/klizz-workshop-1.jpeg',
                    heading: 'CUSTOM CUTTING SERVICES',
                    name01: 'Wood Processing',
                    name02: 'Custom Sizes'
                },
                {
                    id: 2,
                    classnames: 'project-item mdf doors',
                    srcimg: 'assets/img/project/klizz-mdf-boards.jpeg',
                    heading: 'MDF BOARDS & LAMINATES',
                    name01: 'MDF Boards',
                    name02: 'Laminated Sheets'
                },
                {
                    id: 3,
                    classnames: 'project-item plywood hardware',
                    srcimg: 'assets/img/project/klizz-workshop-machine.jpeg',
                    heading: 'PRECISION CUTTING EQUIPMENT',
                    name01: 'Modern Machinery',
                    name02: 'Quality Work'
                },
                {
                    id: 4,
                    classnames: 'project-item doors mdf',
                    srcimg: 'assets/img/project/klizz-door-materials.jpeg',
                    heading: 'DOOR FRAME MATERIALS',
                    name01: 'Door Components',
                    name02: 'Custom Doors'
                },
                {
                    id: 5,
                    classnames: 'project-item plywood mdf',
                    srcimg: 'assets/img/project/klizz-workshop-team.jpeg',
                    heading: 'PROFESSIONAL WORKSHOP',
                    name01: 'Expert Craftsmen',
                    name02: 'Quality Service'
                },
                {
                    id: 6,
                    classnames: 'project-item hardware paints',
                    srcimg: 'assets/img/project/klizz-materials-stock.jpeg',
                    heading: 'WIDE PRODUCT RANGE',
                    name01: 'Building Materials',
                    name02: 'Ready Stock'
                }
            ]
        }
    }

    render() {
        return (
            <div className="themesflat-project style-2 isotope-project has-margin mg15 data-effect clearfix">
                {
                this.state.projects.map(data =>(
                <div className={data.classnames} key={data.id}>
                    <div className="inner">
                        <div className="thumb data-effect-item has-effect-icon w40 offset-v-19 offset-h-49">
                            <img src={data.srcimg} alt={data.heading} />
                            <div className="elm-link">
                                <Link to="#" className="icon-1 icon-search" />
                                <Link to="/contact-01" className="icon-1" />
                            </div>
                            <div className="overlay-effect bg-color-3" />
                        </div>
                        <div className="text-wrap">
                            <h5 className="heading">
                                <Link to="/products">{data.heading}</Link>
                            </h5>
                            <div className="elm-meta">
                                <span>
                                    <Link to="/products">{data.name01}</Link>
                                </span>
                                <span>
                                    <Link to="/products">{data.name02}</Link>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                ))
                }
            </div>
        );
    }
}

export default (TabProject);